import '@/lib/i18n';

import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';
import { cargarAnalytics } from '@/lib/consentimientoCookies';

const cookiesChoice = localStorage.getItem('cookiesChoice');

// Analytics solo con consentimiento previo (no se carga desde index.html).
if (cookiesChoice === 'accepted') cargarAnalytics();

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.VITE_SENTRY_MODE === 'true',
  integrations: [
    Sentry.browserTracingIntegration(),
    // ── Web Vitals (LCP, CLS, INP, FCP, TTFB) ─────────────────────────────
    // Reporta Core Web Vitals reales a Sentry Performance.
    // Ver en: Sentry → Performance → Web Vitals
    Sentry.browserProfilingIntegration(),
    ...(cookiesChoice === 'accepted'
      ? [
          Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
            maskAllInputs: true,
          }),
        ]
      : []),
  ],
  tracesSampleRate: 0.1,
  // 20% de usuarios — sube a 1.0 si el tráfico es bajo
  profilesSampleRate: 0.2,
  replaysSessionSampleRate: cookiesChoice === 'accepted' ? 0.1 : 0,
  replaysOnErrorSampleRate: cookiesChoice === 'accepted' ? 1.0 : 0,
});

createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary fallback={<p>Ha ocurrido un error inesperado.</p>}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </Sentry.ErrorBoundary>
);
